<app-section-presentation *ngIf="section" [course]="course" [section]="section" (reloadErrors)="reloadErrors($event)"></app-section-presentation>

<div *ngFor="let sectionContent of section?.sectionContents; let index=index">
    <app-section-content [course]="course" [section]="section" [sectionContent]="sectionContent" id="sc-{{sectionContent.id}}"></app-section-content>
    <add-section-content [course]="course" [section]="section" [position]="index+1"></add-section-content>
</div>
